export default __webpack_public_path__ + "static/image-API-extract-b5e502cde84ead8503e96cd64dfd7595.png";